import { auth } from './firebase';

// Use Vite's environment variables to determine the API base URL
export const baseURL = (() => {
  switch(import.meta.env.VITE_PROJECT_ID) {
    case "intentscope":
      return "https://queries.contentsage.ai/api";
    case "intentscope-dev":
      return "https://intentscope-dev.web.app/api";
    default:
      return "http://localhost:5000/api";
  }
})();

const getAuthHeaders = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not authenticated");
  }
  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};

export const get = async (path) => {
  const headers = await getAuthHeaders();
  const response = await fetch(`${baseURL}${path}`, { headers });
  if (!response.ok) throw new Error(await response.text());
  return response.json();
};

export const post = async (path, data) => {
  const headers = await getAuthHeaders();
  const response = await fetch(`${baseURL}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(await response.text());
  return response.json();
};

export const del = async (path) => {
  const headers = await getAuthHeaders();
  const response = await fetch(`${baseURL}${path}`, {
    method: 'DELETE',
    headers,
  });
  if (!response.ok) throw new Error(await response.text());
};
